import React from 'react';
import AdminRecordPaymentPage from '../domains/billing/components/AdminRecordPaymentPage';

const AdminRecordPayment: React.FC = () => {
  return <AdminRecordPaymentPage />;
};

export default AdminRecordPayment;

